import { Divider, Typography } from "@trimble/modus-cmx";
import { styled } from "@mui/material";

const StyledDivider = styled(Divider)({
  ".modus-wc-divider": {
    height: 0,
  },
  ".modus-wc-divider-vertical": {
    margin: "0",
  },
});

type MenuHeaderProps = {
  title: string;
};

const MenuHeader = (props: MenuHeaderProps) => {
  const { title } = props;
  return (
    <>
      <Typography
        hierarchy="h6"
        weight="bold"
        style={{
          color: "var(--modus-wc-color-accent)",
          margin: "16px 16px 0 16px",
          paddingBottom: "8px",
          display: "block",
          textAlign: "start",
        }}
      >
        {title}
      </Typography>
      <StyledDivider />
    </>
  );
};

export default MenuHeader;
